import { render, staticRenderFns } from "./templete-list-v2.vue?vue&type=template&id=feafbc86&scoped=true&"
import script from "./templete-list-v2.vue?vue&type=script&lang=js&"
export * from "./templete-list-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feafbc86",
  null
  
)

export default component.exports